import React, { Component } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';

import PubnubWarningMessageContent from 'components/shared/pubnub-warning-message/pubnubWarningMessageContent';

function PubnubWarningMessage(props) {
  const dispatch = useDispatch();
  const pubnubConnectionStatus = useSelector((state) => state.sharedReducer.pubnubConnectionStatus);
  const userProfile = useSelector((state) => state.usersReducer.userProfile);

  if (userProfile && !userProfile.email) {
    // means the user is not logged in so don't render this pubnub warning
    return null;
  }

  const isPubNubHealthy = pubnubConnectionStatus.isClientHealthy && pubnubConnectionStatus.isServerHealthy;
  const isGoingToAutoRefresh = pubnubConnectionStatus.secondsToAutoRefresh !== null;
  const isRefreshingNow = !isPubNubHealthy && pubnubConnectionStatus.secondsToAutoRefresh === 0;

  if (!!isPubNubHealthy || !isGoingToAutoRefresh) {
    // Pubnub is healty OR secondsToAutoRefresh not available, no need to show any warning
    return null;
  }

  return (
    <div>
      <PubnubWarningMessageContent
        isPubNubHealthy={isPubNubHealthy}
        pubnubConnectionStatus={pubnubConnectionStatus}
        userProfile={userProfile}
        dispatch={dispatch}
      />
    </div>
  );
}

export default PubnubWarningMessage;
